import React from 'react';

export default function NavMenuTrigger() {
    return (
        <div className='nav-menu-trigger'>
            <label htmlFor='nav-trigger'>
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
            </label>
        </div>
    );
}
